module.exports = __webpack_public_path__ + "img/round3-variation2.41160d60.gif";